// Cloudflare Turnstile render options that follow the site's light/dark toggle.
//
// Turnstile's own `theme: 'auto'` follows the OS `prefers-color-scheme`, which would
// disagree with our class-based toggle (a dark site on a light OS would still render a
// light widget), so we map the theme explicitly from useColorMode.
//
// Note: the widget renders once, so changing the theme after mount doesn't re-skin an
// already-rendered widget (it picks up the new theme on the next render/reload). That's
// deliberate — forcing a re-render would reset the challenge token.
export const useTurnstileTheme = () => {
  const colorMode = useColorMode();
  return computed(() => ({
    theme: colorMode.value === "dark" ? "dark" : "light",
  }));
};
